module.exports = __webpack_public_path__ + "img/ml-bg.6f917816.png";